import { useTranslation } from 'react-i18next';
import { Button, Collapse, Drawer, Form, Space, Typography } from 'antd'
import { useEffect, useState } from 'react'
import { getDetailMinistryAccount } from '../../../service/list-acoount-ministry/listAccountMinistry'
import "./index.scss"

type Props = {
  open: boolean
  onClose: () => void
  detailData: any
  isEdit: boolean
}

export default function DetailDepartmentalUserAccountDrawer(props: Props) {
  const { t } = useTranslation();
  const { open, onClose, detailData } = props
  const [form] = Form.useForm()
  const { Panel } = Collapse;
  const [dataDetail, setDataDetail] = useState<any>({})

  const getListDataDetail = async () => {
    await getDetailMinistryAccount(detailData?.id).then((res) => {
      if (res.status === 200) {
        setDataDetail(res.data?.data)
      }
    })
  }

  useEffect(() => {
    if (open) {
      getListDataDetail();
    }
  }, [open]);

  return (
    <Drawer
      title={t("Xem chi tiết tài khoản người dùng cấp bộ", "Xem chi tiết tài khoản người dùng cấp bộ")}
      open={open}
      onClose={onClose}
      className='detail-departmental-user-account-drawer'
      width={736}
      bodyStyle={{ padding: "0px" }}
      extra={
        <Space>
          <Button onClick={onClose}>{t("Đóng", "Đóng")}</Button>
        </Space>
      }
    >
      <Form
        className="detail-departmental-user-account-admin"
        layout={"vertical"}
        form={form}
        name="form-detail-departmental-user-account-admin"
      >
        <div>
          <Collapse defaultActiveKey={["1", "2"]}>
            <Panel
              header={t("Thông tin người dùng", "Thông tin người dùng")}
              key="1"
              className="setting-chapter-title">
              <div className='m-5'>
                <span className='flex'><Typography.Title level={5} className='min-w-[160px]'>{t("Đơn vị", "Đơn vị")}</Typography.Title> <p className='mt-0.5 ml-2'>{dataDetail?.unitName}</p></span>
                <span className='flex mt-2'><Typography.Title level={5} className='min-w-[160px]'>{t("Người dùng", "Người dùng")}</Typography.Title> <p className='mt-0.5 ml-2'>{dataDetail?.name}</p></span>
              </div>
            </Panel>

            <Panel
              header={t("Thông tin tài khoản", "Thông tin tài khoản")}
              key="2"
              className="setting-chapter-title">
              <div className='m-5'>
                <span className='flex mt-2'><Typography.Title level={5} className='min-w-[160px]'>{t("Email đăng nhập", "Email đăng nhập")}</Typography.Title> <p className='mt-0.5 ml-2'>{dataDetail?.username}</p></span>
                <span className='flex mt-2'><Typography.Title level={5} className='min-w-[160px]'>{t("Vai trò", "Vai trò")}</Typography.Title>
                  {
                    dataDetail?.roles?.map((item: any) => (
                      <p className='mt-0.5 ml-2'>{item?.name}</p>
                    ))
                  }
                </span>
                <span className='flex mt-2'><Typography.Title level={5} className='min-w-[160px]'>{t("Trạng thái", "Trạng thái")}</Typography.Title> <p className='mt-0.5 ml-2'>{dataDetail?.isActive ? t("Mở khóa", "Mở khóa") : t("Khóa", "Khóa")}</p></span>
              </div>
            </Panel>
          </Collapse>
        </div>
      </Form>
    </Drawer>
  )
}
